import React, { useRef } from "react";
import Select, { components } from "react-select";
import { Icon } from "@iconify/react/dist/iconify.js";
import Flatpickr from "react-flatpickr";
import "../style/f-filters.css";

function FFilters({
  searchText,
  setSearchText,
  date,
  setDate,
  selectedFilter,
  setSelectedFilter,
  quickFilters,
  clearFilters,
  setSearchProductTitle,
  searchProductTitle,
  selectedQuickFilter,
  setSelectedQuickFilter,
}) {
  const flatpickrRef = useRef();
  const options = [
    { value: "all", label: "All Booking" },
    { value: "completed", label: "Completed Booking" },
    { value: "pending", label: "Pending Booking" },
    { value: "expired", label: "Expired Booking" },
  ];

  // Custom SingleValue Component to add the filter icon
  const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <span className="fp-filters-select-icon-start">
        <Icon icon="basil:filter-outline" fontSize={20} />
      </span>
      {children}
    </components.SingleValue>
  );

  // Custom DropdownIndicator Component to add the down arrow
  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <Icon icon="iconoir:nav-arrow-down" fontSize={18} />
    </components.DropdownIndicator>
  );

  return (
    <div className="fp-filters-container">
      <div className="d-flex flex-1 gap-2">
        {/* Search bar */}
        <div className="fp-filters-search d-flex align-items-center gap-2">
          <Icon icon="pajamas:search" fontSize={20} />
          <input
            type="text"
            placeholder="Search here"
            value={searchProductTitle}
            onChange={(e) => setSearchProductTitle(e.target.value)}
            className="fp-filters-search-input"
          />
        </div>

        {/* Date selector */}
        <div className="fp-filters-date d-flex align-items-center gap-2">
          <div className="dod-schedule-date-container position-relative">
            <span
              className="dod-schedule-calender-icon me-2"
              onClick={() => flatpickrRef.current.flatpickr.open()}
            >
              <Icon icon="uis:calender" fontSize={20} />
            </span>
            <Flatpickr
              className="dod-schedule-flatpickr-container"
              name="startDate"
              placeholder="Select Date"
              value={date}
              options={{
                dateFormat: "l, M j, Y",
                static: true,
                disableMobile: true,
              }}
              ref={flatpickrRef}
              onChange={([date]) => {
                const selectedDate = date ? new Date(date) : null;

                // Convert to UTC (if needed)
                if (selectedDate) {
                  selectedDate.setMinutes(
                    selectedDate.getMinutes() - selectedDate.getTimezoneOffset()
                  );
                }

                setDate(selectedDate);
              }}
            />
          </div>
        </div>

        {/* Dropdown selector */}
        <div className="fp-filters-dropdown">
          <Select
            options={options}
            value={options.find((option) => option.value === selectedFilter)}
            onChange={(selected) => setSelectedFilter(selected.value)}
            placeholder="All Booking"
            classNamePrefix="fp"
            components={{ SingleValue, DropdownIndicator }}
          />
        </div>
      </div>

      {/* Quick Filters */}
      <div className="fp-filters-quick-filters d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <div className="fp-filters-icon">
            <Icon
              icon={"heroicons-solid:filter"}
              fontSize={20}
              className="me-1"
            />{" "}
            <span className="fp-filter-title">Quick filters:</span>
          </div>

          {quickFilters.map((filter, index) => (
            <span
              key={index}
              className={`fp-filters-quick-filter-item ${
                selectedQuickFilter?.includes(filter.value) ? "active" : ""
              }`}
              onClick={() => {
                if (selectedQuickFilter?.includes(filter.value)) {
                  setSelectedQuickFilter(
                    selectedQuickFilter.filter((item) => item !== filter.value)
                  );
                } else {
                  setSelectedQuickFilter([
                    ...selectedQuickFilter,
                    filter.value,
                  ]);
                }
              }}
            >
              {filter.label}
            </span>
          ))}
        </div>
        <div className="fp-clear-filters" onClick={clearFilters}>
          <Icon icon="ic:twotone-close" fontFamily={18} className="me-1" />{" "}
          Clear all filters
        </div>
      </div>
    </div>
  );
}

export default FFilters;
